import api from '../../plugins/api';

const pkbPollConsent = (consentRequestId) => {
  return api.get('/api/crm/clients/pkb/pollConsent', { consentRequestId });
};

export default pkbPollConsent;
